import "./SnapWidgetPrivacyPolicy.css";

const updatedAt = "May 18, 2026";

const sections = [
  {
    title: "1. Zero Tolerance",
    body: [
      "SnapWidget has zero tolerance for child sexual abuse and exploitation, including child sexual abuse material, grooming, sextortion, trafficking, or any conduct that sexualizes or harms minors.",
      "Users may not create, upload, share, request, store, or promote content involving sexual exploitation or abuse of minors."
    ]
  },
  {
    title: "2. Prohibited Conduct and Content",
    body: [
      "Prohibited content includes real, synthetic, AI-generated, illustrated, or edited content that depicts, promotes, solicits, normalizes, or attempts to facilitate child sexual abuse or exploitation.",
      "Prohibited behavior includes attempting to contact minors for sexual purposes, asking minors for intimate images, sharing sexualized comments about minors, or using SnapWidget to coordinate off-platform abuse."
    ]
  },
  {
    title: "3. Reporting",
    body: [
      "Anyone can report suspected child safety violations by emailing support@blackdoorapps.com with enough detail for us to investigate, such as usernames, timestamps, screenshots, or a description of the concern.",
      "If someone is in immediate danger, contact local emergency services or law enforcement first."
    ]
  },
  {
    title: "4. Review and Enforcement",
    body: [
      "We review reports and may remove content, restrict features, suspend accounts, terminate accounts, preserve evidence, and take other action needed to protect users and the public.",
      "Where appropriate or required by law, we may report suspected child sexual abuse material or exploitation to relevant authorities, child safety organizations, or law enforcement."
    ]
  },
  {
    title: "5. Cooperation With Authorities",
    body: [
      "BlackDoor will cooperate with lawful requests from law enforcement and child safety authorities related to child sexual abuse and exploitation investigations.",
      "We may retain relevant account, device, report, and content information when necessary to comply with legal obligations, protect safety, or support an investigation."
    ]
  },
  {
    title: "6. Prevention and Product Safety",
    body: [
      "SnapWidget is designed for private photo sharing with people users choose to connect with. We use account controls, reporting channels, and enforcement processes to reduce misuse.",
      "We continue to evaluate safety processes and may update these standards as product features, legal requirements, and child safety best practices evolve."
    ]
  },
  {
    title: "7. Contact",
    body: [
      "For child safety concerns, policy questions, or enforcement appeals, contact BlackDoor at support@blackdoorapps.com."
    ]
  }
];

export default function SnapWidgetCsaeStandards() {
  return (
    <main className="snap-policy-page">
      <section className="snap-policy-hero">
        <a className="snap-policy-brand" href="/">
          BlackDoor
        </a>
        <p className="snap-policy-kicker">SnapWidget Safety</p>
        <h1>Child Safety Standards</h1>
        <p className="snap-policy-updated">Last updated {updatedAt}</p>
        <p className="snap-policy-summary">
          These standards explain how BlackDoor prohibits, reviews, reports, and enforces against child sexual abuse and exploitation on SnapWidget.
        </p>
      </section>

      <section className="snap-policy-content">
        <article className="snap-policy-card snap-policy-intro">
          <p>
            SnapWidget must never be used to exploit, endanger, sexualize, coerce, or abuse minors. These standards apply to all users, content, messages, profile information, and activity connected to SnapWidget.
          </p>
        </article>

        {sections.map((section) => (
          <article className="snap-policy-card" key={section.title}>
            <h2>{section.title}</h2>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </article>
        ))}
      </section>
    </main>
  );
}
